module.exports = __webpack_public_path__ + "img/flower-04.523d9b38.png";